export default __webpack_public_path__ + "static/media/gaylord-palms.6792a909.jpg";